import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const copyToAll: ISVGPersonalProps = {
  viewBox: '0 0 24 24',
  content: (
    <g id="copt_to_all_icon" data-name="copt to all icon" transform="translate(1336 -7776)">
      <rect
        id="Rectangle_3000"
        data-name="Rectangle 3000"
        width="24"
        height="24"
        transform="translate(-1336 7776)"
        fill="none"
      />
      <path
        id="Path_7134"
        data-name="Path 7134"
        d="M12.469,0H5.344A2.474,2.474,0,0,0,2.969,2.375l-.686.016A2.378,2.378,0,0,0,0,4.75V16.625A2.474,2.474,0,0,0,2.375,19h8.906a2.474,2.474,0,0,0,2.375-2.375h.594a2.474,2.474,0,0,0,2.375-2.375V4.764ZM11.281,17.813H2.375a1.245,1.245,0,0,1-1.187-1.188V4.75A1.177,1.177,0,0,1,2.319,3.582l.65-.02V14.25a2.474,2.474,0,0,0,2.375,2.375h7.125a1.245,1.245,0,0,1-1.187,1.188m4.156-3.563a1.245,1.245,0,0,1-1.188,1.187H5.344A1.245,1.245,0,0,1,4.156,14.25V2.375A1.245,1.245,0,0,1,5.344,1.188h5.938c-.01,1.367,0,2.39,0,2.39a2.446,2.446,0,0,0,2.375,2.36h1.781Zm-1.781-9.5c-.632,0-1.187-1.149-1.187-1.765V1.206h0L15.438,4.75ZM12.469,8.323H7.125a.593.593,0,1,0,0,1.186h5.344a.593.593,0,1,0,0-1.186m0,2.966H7.125a.593.593,0,1,0,0,1.186h5.344a.593.593,0,1,0,0-1.186"
        transform="translate(-1332.379 7778.271)"
        fill="#79cdd0"
      />
    </g>
  ),
};
